<template>
  <div id="container">
    <div class="whitetext">telebarq</div>
    <div class="pencil pointer" @click="writeOwnTele">
      <img src="../assets/pencil.svg" />
    </div>
    <div class="white">
      <div
        class="telebarqs"
        @click="openTelebarq(T, false)"
        v-for="T in telebarqs"
        :key="T"
      >
        <div class="headText">{{ T }}</div>
        <div class="text">{{ getText(T) }}</div>
      </div>
    </div>
    <Transition>
      <div v-if="currentOpenTele" class="Telebarq_PopUp">
        <div class="innerPopUp" :style="imageStyle">
          <!-- <div class="close" @click="closeTelebarq" :class="closeClass"></div> -->
          <div class="close pointer" @click="closeTelebarq" :class="closeClass">
            <img src="../assets/close.svg" />
          </div>
          <div
            v-if="replyTele"
            class="send pointer"
            :class="replyClass"
            @click="sendTele"
          >
            <img src="../assets/send.svg" />
          </div>
          <div
            v-if="!replyTele"
            class="reply pointer"
            :class="replyClass"
            @click="telebarqReply"
          >
            <img src="../assets/reply.svg" />
          </div>
          <!-- <div
            v-if="!currentOpenTele.includes('Frabank')"
            class="reply"
            @click="telebarqReply"
          ></div> -->
          <template v-for="(s, i) in teles[currentOpenTele].special" :key="s">
            <input
              v-if="s.type == 'input'"
              v-model="inputs[i]"
              type="text"
              :style="s.style"
              class="abs"
            />
            <textarea
              v-if="s.type == 'textarea'"
              v-model="textarea"
              maxlength="330"
              :style="s.style"
              class="abs text2"
            />
            <Canvas
              v-if="s.type == 'canvas'"
              class="abs"
              ref="VueCanvasDrawing_tele"
              :width="s.width"
              :height="s.height"
              :style="s.style"
              :sendImg="sendImg"
              @img="setImg"
            />
          </template>
        </div>
        <div v-if="replyTele" class="replyTele">
          <div class="replyBorder"></div>
          <div>{{ t("your_reply") }}</div>
          <textarea
            v-model="textarea"
            class="text1"
            cols="1"
            rows="5"
            maxlength="250"
          ></textarea>
        </div>
      </div>
    </Transition>
    <Transition>
      <div v-if="writeTele" class="Telebarq_PopUp writeTele">
        <div class="innerPopUp gray">
          <div class="orange_border">
            <div class="top">
              <div class="newmessageto">
                {{ t("NEW MESSAGE TO:") }}
              </div>
              <div class="actors">
                <div
                  v-for="(a, i) in actors"
                  :key="a"
                  @click="selectActor(i)"
                  class="pointer"
                  :class="selected_actor == i ? 'selected_actor' : ''"
                >
                  {{ a }}
                </div>
              </div>

              <div class="close pointer" @click="closeTelebarq">
                <img src="../assets/close.svg" />
              </div>
              <div class="send pointer" @click="send_own_Tele">
                <img src="../assets/send.svg" />
              </div>
            </div>

            <div class="writeTele_white">
              <div class="content">
                <textarea
                  v-model="textarea"
                  class="text1"
                  cols="1"
                  rows="5"
                  maxlength="250"
                  style="font-size: 17px"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import Teles from "../../telebarq.json";
import Canvas from "./Canvas.vue";
import Dict from "../../services/dict_new.js";

export default {
  name: "Telebarq",
  components: { Canvas },
  emits: ["resetPopUp", "msg", "addToPlayerData"],
  props: {
    telebarqs: {
      type: Array,
      default: () => [],
    },
    tele: {
      type: String,
      default: () => "",
    },
    sprache: {
      type: String,
      default: () => "english",
    },
    showPopUp: {
      type: Boolean,
      default: () => false,
    },
    userName: {
      type: String,
      default: () => "[no User specified]",
    },
  },
  watch: {
    showPopUp: function (newVal) {
      console.log("^^^^^^^^^^^^^^^^^^^^^^");
      // watch it
      if (newVal) {
        console.log("%%%%%%%%%%%%%%%%%%%%%%");
        this.openTelebarq(this.telebarqs[0], true);
      }
      this.$emit("resetPopUp");
    },
  },
  data() {
    return {
      currentOpenTele: "",
      closeClass: "",
      imageStyle: "",
      replyTele: "",
      writeTele: false,
      textarea: "",
      inputs: [],
      coolDownTimer: null,
      teles: Teles,
      actors: [
        "ROYA",
        "LARRY",
        "FRABANK",
        "XENIA",
        "ANDRE",
        "SALLY",
        "AISHA",
        "EMMA",
        "JUAN",
      ],
      selected_actor: null,

      x: 0,
      y: 0,
      image: "",
      eraser: false,
      disabled: false,
      fillShape: false,
      line: 5,
      color: "#000000",
      strokeType: "dash",
      backgroundColor: "transparent",
      imgsrc: "",
      sendImg: false,
    };
  },

  methods: {
    t(word) {
      return Dict(word, this.sprache);
    },
    resetOpen() {
      this.textarea = "";
      this.inputs = [];
    },
    selectActor(i) {
      this.selected_actor = i;
    },
    send_own_Tele() {
      if (!this.textarea) {
        this.$emit("msg", this.t("no_input"));
        return;
      }

      // console.log(this.textarea);
      let data = {
        id: Date.now(), //time
        userName: this.userName,
        teleId: "own",
        rawData: this.textarea,
        sprache: this.sprache,
        type: "telebarq_reply",
        actor: this.selected_actor,
        special: false,
      };
      console.log("sending");
      this.$emit("addToPlayerData", data);
      this.$emit("msg", this.t("tele_sent"));
      this.closeTelebarq();
      // this.addToPlayerData(data);
    },
    writeOwnTele() {
      this.writeTele = true;
    },
    checkCoolDown(time) {
      if (this.coolDownTimer) {
        if (time < 30) {
          this.$emit(
            "msg",
            this.t("please wait at least") +
              " " +
              time +
              " " +
              this.t("seconds to close this Telebarq")
          );
        } else {
          this.$emit("msg", this.t("please try again in a few moments"));
        }
        return true;
      }
      return false;
      // this.coolDownTimer = setTimeout(() => {
      //   this.coolDownTimer = null;
      // }, 5000);
      // return false;
    },
    startCoolDown(time) {
      console.log("STARTCOOLDOWN");
      this.coolDownTimer = setTimeout(() => {
        this.coolDownTimer = null;
        console.log("cooldown beendet %%%%%%%%%%%%");
      }, time * 1000);
    },
    getText(T) {
      if (!Teles[T]) return "...";
      return Teles[T][this.sprache].substring(0, 100) + "...";
    },
    // openTele(T) {
    //   this.$emit("open", T);
    //   console.log(this.currentOpenTele);
    // },
    setImg(img) {
      console.log("child send functoin!");
      this.sendImg = false;
      try {
        let data = {
          id: Date.now(), //time
          userName: this.userName,
          teleId: this.currentOpenTele,
          rawData: {
            canvas: img,
            inputs: this.inputs,
            textarea: this.textarea,
          },
          sprache: this.sprache,
          type: "telebarq_reply",
          special: true,
        };
        console.log("sending");
        this.$emit("addToPlayerData", data);
        this.$emit("msg", this.t("tele_sent"));
        this.closeTelebarq();
      } catch (e) {
        console.log(e);
        this.$emit("msg", "drawing error, cannot send reply");
      }
    },
    sendTele() {
      let rawdata = {};
      let special;
      console.log(this.teles[this.currentOpenTele]);
      try {
        if (this.teles[this.currentOpenTele].special) {
          console.log("hasspecial");
          for (
            var i = 0;
            i < this.teles[this.currentOpenTele].special.length;
            i++
          ) {
            if (this.teles[this.currentOpenTele].special[i].type == "canvas") {
              console.log("HAS canvas, let child handle the sending");
              //continue in setImg function, wait for reply from child
              this.sendImg = true;
              return;
            }
          }

          // if (this.$refs.VueCanvasDrawing_tele.isEmpty()) {
          //   this.$emit("msg", this.t("no_input"));
          //   return;
          // }
          rawdata.inputs = this.inputs;
          rawdata.textarea = this.textarea;

          special = true;
        } else {
          if (!this.textarea) {
            this.$emit("msg", this.t("no_input"));
            return;
          }
          rawdata = {
            textarea: this.textarea,
          };
          special = false;
        }
        // console.log(this.textarea);
        let data = {
          id: Date.now(), //time
          userName: this.userName,
          teleId: this.currentOpenTele,
          rawData: rawdata,
          sprache: this.sprache,
          type: "telebarq_reply",
          special: special,
        };
        console.log("sending");
        this.$emit("addToPlayerData", data);
        this.$emit("msg", this.t("tele_sent"));
        this.closeTelebarq();
      } catch (e) {
        console.log(e);
        this.$emit("msg", "drawing error, cannot send reply");
      }

      this.resetOpen();
      // this.addToPlayerData(data);
    },
    openTelebarq(T, coolDown) {
      console.log(Teles[T]);
      console.log("OPEN Telebarq with: " + coolDown);
      if (!Teles[T]) return;
      this.currentOpenTele = T;
      this.closeClass = "close_normal";
      this.replyClass = "reply_normal";
      if (T.includes("Frabank")) {
        this.closeClass = "close_frabank";
        this.replyClass = "reply_frabank";
      }
      this.loadTele(T);
      if (!Teles[T].timer) return;
      if (coolDown) this.startCoolDown(Teles[T].timer);
    },
    closeTelebarq() {
      if (this.currentOpenTele) {
        if (this.checkCoolDown(Teles[this.currentOpenTele].timer)) return false;
      } else {
        if (this.checkCoolDown(5)) return false;
      }

      this.currentOpenTele = "";
      this.replyTele = "";
      this.textarea = "";
      this.writeTele = false;
    },
    telebarqReply() {
      console.log("Opening reply");
      if (this.teles[this.currentOpenTele].special) {
        console.log("has speical, just send it");
        this.sendTele();
      }
      console.log("Opening reply2");
      this.replyTele = this.currentOpenTele;
    },
    loadTele(teleId) {
      // console.log("TRYOING TO LOAD:" + teleId);
      let img = "";
      let img2 = "";
      try {
        img = require("../assets/Telebarq/" +
          this.sprache +
          "/" +
          teleId +
          ".png");
      } catch (e) {
        console.log("img not found");
        this.$emit("msg", "Could not load Telebarq1");
        // this.currentOpenTele = "";
      }
      try {
        img2 = require("../assets/Telebarq/" +
          this.sprache +
          "/min/" +
          teleId +
          ".jpg");
      } catch (e) {
        console.log(e);
        this.$emit("msg", "Could not load Telebarq2");
        // this.currentOpenTele = "";
      }
      this.imageStyle =
        "background-image: url('" + img + "'),url('" + img2 + "');";
      // console.log(this.imageStyle);
      return img;
    },
  },
  created() {
    // console.log(
    //   "TELEBARQ CREATED +++++++++++++++++++++++++++++++++++++++++++++"
    // );
    // console.log(this.telebarqs);
  },
  mounted() {
    // console.log(
    //   "TELEBARQ MOUNTED ++++++++++++++++++++++++++++++++++++++++++++"
    // );
  },
};
</script>

<style scoped>
.newmessageto {
  text-align: center;
  max-width: 140px;
  color: var(--barq-orange);
}

.writeTele textarea {
  height: 340px;
}

.top {
  position: relative;
  display: flex;
  align-items: center;
}
.orange_border {
  border: 4px solid var(--barq-orange);
  margin: 10px;
  border-radius: 20px;
  height: calc(100% - 48px);
  padding: 10px;
}

.actors {
  display: flex;
  width: 240px;
  flex-wrap: wrap;
}

.actors > div {
  flex: 0 0 62px;
  background: white;
  margin: 2px;
  padding: 3px;
  text-align: center;
  border: 3px solid var(--barq-orange);
  color: var(--barq-orange);
  border-radius: 7px;
  font-size: 12px;
}

.actors > div:hover {
  background: var(--barq-orange);
  color: white;
  border: 3px solid white;
}

.selected_actor {
  background: var(--barq-orange) !important;
  color: white !important;
  border: 3px solid white !important;
}

.gray {
  background: #f2f2f2;
}

.writeTele .send {
  right: 40px;
  top: 0px;
}

.writeTele .close {
  width: 27px;
  height: 27px;
  right: 0px;
  top: 0px;
}

.pencil {
  border: 2px solid var(--barq-orange);
  width: 25px;
  height: 25px;
  border-radius: 50%;
  position: absolute;
  background: white;
  right: 14px;
  top: 20px;
}

.pencil:hover {
  background: var(--barq-orange);
  border: 2px solid white;
}

.pencil:hover img {
  filter: brightness(10);
}

.pencil > img {
  width: 20px;
  position: absolute;
  top: calc(50% - 1px);
  left: calc(50%);
  transform: translateY(-50%) translateX(-50%);
}

.close {
  border: 2px solid var(--barq-orange);
  width: 25px;
  height: 25px;
  border-radius: 50%;
  position: relative;
  background: white;
  margin-left: 10px;
}

.close:hover,
.reply:hover {
  background: var(--barq-orange);
}

.close:hover img {
  filter: brightness(10);
}

.close > img {
  width: 25px;
  position: absolute;
  top: calc(50%);
  left: calc(50%);
  transform: translateY(-50%) translateX(-50%);
}

.send:hover {
  background: var(--barq-orange);
}

.send:hover img,
.close:hover img,
.reply:hover img {
  filter: brightness(10);
}

.send > img {
  width: 21px;
  position: absolute;
  top: calc(50% + 1px);
  left: calc(50% - 1px);
  transform: translateY(-50%) translateX(-50%);
}

.send {
  position: absolute;
  right: 67px;
  top: 70px;
  width: 27px;
  height: 27px;
  background: white;
  border: 2px solid var(--barq-orange);
  border-radius: 20px;
  z-index: 4;
}

.pointer:hover {
  cursor: pointer;
}

.text1 {
  width: 90%;
  margin: 0 auto;
}

textarea {
  resize: none;
  display: block;
  overflow: hidden;
}

.abs {
  position: absolute;
}

.close {
  position: absolute;
  /* border: 1px solid red; */
}

.close:hover,
.reply:hover {
  cursor: pointer;
}

.reply_frabank {
  top: 2% !important;
  right: 12% !important;
  width: 6% !important;
  aspect-ratio: 1;
  height: auto !important;
}

.close_frabank {
  top: 2% !important;
  right: 2.5% !important;
  width: 6% !important;
  aspect-ratio: 1;
  height: auto !important;
}

.close_frabank > img {
  width: 28px !important;
}

.close_normal > img {
  width: 100% !important;
}

.reply_normal > img {
  width: 80% !important;
}

.close_normal {
  top: 13.5% !important;
  right: 5% !important;
  width: 7% !important;
  aspect-ratio: 1;
  height: auto !important;
}

.reply_normal {
  top: 13.5% !important;
  right: 13% !important;
  width: 7% !important;
  aspect-ratio: 1;
  height: auto !important;
}

.reply {
  position: absolute;
  right: 12vh;
  top: 12.5vh;
  width: 5.5vh;
  height: 5.5vh;
  background: white;
  border: 2px solid var(--barq-orange);
  border-radius: 50%;
  z-index: 4;
}

.reply > img {
  width: 22px;
  position: absolute;
  top: calc(50% - 1px);
  left: calc(50% - 1px);
  transform: translateY(-50%) translateX(-50%);
}

.replyTele {
  position: absolute;
  bottom: calc(50% - 317px);
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  width: 440px;
  text-align: center;
  color: var(--barq-orange);
  background: white;
  padding: 30px 0px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.replyTele > div {
  margin-bottom: 15px;
}

.replyBorder {
  width: 90%;
  margin: 0 auto;
  border-top: 3px solid var(--barq-orange);
}

.Telebarq_PopUp {
  position: fixed;
  z-index: 2;
  background: hsl(19deg 97% 56% / 15%);
  height: 100%;
  top: 0px;
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
  width: 100%;
  left: 0px;
}

.innerPopUp {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  width: 90vh;
  max-width: 690px;
  aspect-ratio: 1000/976;
  background-repeat: no-repeat, no-repeat;
  background-size: 100%;
  border-radius: 18px;
}

.middleText {
  font-size: 20px;
}

.telebarqs {
  border-bottom: 1px solid black;
  padding: 10px 0;
}

.telebarqs:hover {
  cursor: pointer;
}

.text {
  font-size: 0.9em;
  color: #434343;
}

.whitetext {
  color: white;
  text-align: left;
  line-height: 1.5em;
  font-size: 1.5em;
}

.white {
  height: 94%;
  background: #f2f2f2;
  border: 2px solid white;
  border-radius: 2px;
  font-size: 14px;
  padding: 0 10px;
  text-align: left;
  overflow: scroll;
}

#container:before {
  border: 2px solid white;
  content: "";
  width: calc(100% - 6px);
  height: calc(100% - 6px);
  position: absolute;
  top: 1px;
  left: 1px;
  border-radius: 13px;
  pointer-events: none;
}

#container {
  background-color: var(--barq-orange);
  position: relative;
  border-radius: 20px;
  border: 6px solid white;
  padding: 1em;
  margin-right: 1em;
  width: 200px;
  text-align: right;
  height: 570px;
  font-family: Calibri;
}
</style>
